module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_14.9dc8f2e3.pdf";